export default class FileInputCustom {
    constructor(options) {
        this.wrapper = options.wrapper;
        this.inputElement = options.inputElement;
        this.fileNameElement = options.fileNameElement;
        this.resetButton = options.resetButton;
        this.resetButtonSelector = options.resetButtonSelector;
        this.classToAdd = options.classToAdd;
        this.defaultFileNameText = this.fileNameElement.textContent || ''; // ファイル名の初期値を取得
        this.initEventListeners(); // イベントリスナーを初期化
    }

    handleInputChange() { // input要素のchangeイベントハンドラ
        const file = this.inputElement.files.length > 0 ? this.inputElement.files[0] : null; // 選択されたファイルを取得
        this.fileNameElement.textContent = file ? file.name : this.defaultFileNameText; // ファイル名を表示
        this.toggleResetButtonClass(); // リセットボタンにクラスを追加
    }

    resetFileInput() { // リセットボタンのクリックイベントハンドラ
        this.inputElement.value = ''; // input要素の値をリセット
        this.fileNameElement.textContent = this.defaultFileNameText; // ファイル名をリセット
        this.toggleResetButtonClass(); // リセットボタンにクラスを追加
    }

    toggleResetButtonClass() { // リセットボタンにクラスを追加するメソッド
        const resetButton = this.wrapper.querySelector(this.resetButtonSelector);
        if (resetButton) {
            if (this.inputElement.value !== '') {
                resetButton.classList.add(this.classToAdd);
            } else {
                resetButton.classList.remove(this.classToAdd);
            }
        }
    }

    initEventListeners() { // イベントリスナーを初期化
        this.inputElement.addEventListener('change', this.handleInputChange.bind(this)); // input要素にchangeイベントリスナーを追加
        if (this.resetButton) { // リセットボタンが存在すれば
            this.resetButton.addEventListener('click', this.resetFileInput.bind(this)); // リセットボタンにクリックイベントリスナーを追加
        }
    }
}